import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';
import { Alert, Button, Row } from 'antd';
import { connect } from 'react-redux';
import { path } from 'ramda';

import { login } from 'constants/routes';
import { patchPasswordReset } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';

const validationSchema = yup.object({
    secret_token: yup.string().required(),
    password: yup.string().required(),
    password_confirm: yup.string().required(),
});

@connect((state, props) => ({
    initialValues: {
        secret_token: path(['match', 'params', 'token'], props)
    }
}))
@withAutoFocusForm
@withAsyncActions({
    formAction: patchPasswordReset
        .withSuccessHandler(({ history }) => {
            history.push(login.path);
        })
}, { resetOnMount: true })
@withForm({
    validationSchema: validationSchema,
})
export default class PasswordReset extends Component {
    render() {
        return (
            <div className="promo-form">
                <Alert className="m-b-30" message="Пароль должен состоять не менее чем из 8 символов" type="info" />
                <Field
                    name='password'
                    type='password'
                    component={Input}
                    placeholder='Пароль'
                />
                <Field
                    name='password_confirm'
                    type='password'
                    component={Input}
                    placeholder='Повторите пароль'
                />
                <Row className="form-row m-b-20">
                    <Button type='primary' size='large' htmlType='submit'>
                        Сохранить
                    </Button>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/PasswordReset.js